import React, { Component } from "react"
import PropTypes from "prop-types"

class Input extends Component {
	constructor(props) {
		super(props)
		this.addCount = this.addCount.bind(this)
	}

	state = {
		count: this.props.count,
	};

	addCount = (id) => {
		window.dispatchEvent(new Event("on-storage"))
		const storage = []

		JSON.parse(localStorage.getItem("enquiry-product")).forEach((item) => {
			if (item.id === id) {
				item.count = this.input.value
			}
			storage.push(item)
		})

		localStorage.setItem("enquiry-product", JSON.stringify(storage))

	};

	render() {
		return (
            <input ref={(input) => { this.input = input }} onChange={() => { this.addCount(this.props.id) }} type="number" defaultValue={this.state.count} />
		)
	}
}

Input.propTypes = {
	count: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
}
export default Input